import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { MessageScreen } from '../../components/error/MessageScreen';

export const FatalError = () => {
  return (
    <Box>
      {' '}
      {/* Box to prevent flex height 100% */}
      <Alert severity="error" icon={<ErrorOutlineIcon />} sx={{ p: 4, mt: 5, mx: 'auto' }}>
        <AlertTitle>
          <FormattedMessage
            id="common.fatalError.title"
            defaultMessage="Oops! Ha ocurrido un error"
          />
        </AlertTitle>
        <Box sx={{ mt: 3 }}>
          <FormattedMessage
            id="common.fatalError.body"
            defaultMessage="Prueba a recargar la página o <a>inicia sesión nuevamente</a>.{br}Si el error persiste, contactate con nosotros."
            values={{
              a: (v: React.ReactNode) => (
                <Typography
                  component="a"
                  href="/logout"
                  sx={{
                    fontWeight: 500,
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                >
                  {v}
                </Typography>
              ),
              br: <br />,
            }}
          />
        </Box>
      </Alert>
    </Box>
  );
};

export function FatalErrorScreen() {
  return (
    <MessageScreen>
      <FatalError />
    </MessageScreen>
  );
}
